import Slider from "react-slick";
import { CustomNextArrow, CustomPrevArrow } from "../CustomArrow";
import { motion } from "framer-motion";

const BeforeAfterCarousel = ({ language, images }) => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 3500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  // Normalize images data to always be in object format
  const normalizedImages = images.map((item) => {
    if (typeof item === "string") {
      return {
        src: item,
        alt: `${language === "en" ? "Before & After" : "قبل وبعد"} image`,
      };
    }
    return item;
  });

  return (
    <>
      <div className="text-center mb-5">
        <h2 className="fw-bold h1 mb-3" style={{ color: "#c69933" }}>
          {language === "en" ? "Before & After" : "قبل وبعد"}
        </h2>
      </div>
      <div className="px-lg-5">
        <Slider {...sliderSettings}>
          {normalizedImages.map((image, index) => (
            <motion.div
              key={index}
              variants={fadeInUp}
              className="px-2" // Add horizontal padding between slides
            >
              <div className="before-after-slide">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="img-fluid rounded-4 w-100"
                  style={{
                    height: "300px",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                  onError={(e) => {
                    e.target.src = "/path-to-fallback-image.jpg"; // Add fallback image
                    e.target.alt = "Image not available";
                  }}
                />
              </div>
            </motion.div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default BeforeAfterCarousel;
